import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  Department,
  Gender,
  JobTitle,
  OfficeLocation,
  Status,
} from "models/org-chart-node";
import { EmployeeType } from "models/employee-type";
import Employee, { DEFAULT_EMPLOYEE_QUERY, IEmployeeQueryParams } from "models/employee";

export interface EmployeesSliceState {
  employee: Employee | null;
  isLoadingEmployees: boolean;
  employeeCount: number;
  jobTitles: JobTitle[];
  officeLocations: OfficeLocation[];
  genders: Gender[];
  employees: Employee[];
  managers: Employee[];
  departments: Department[];
  employeeTypes: EmployeeType[]
  status: Status[];
  query: IEmployeeQueryParams;
}

export const initialState: EmployeesSliceState = {
  employees: [],
  employee: null,
  isLoadingEmployees: true,
  employeeCount: 0,
  jobTitles: [],
  officeLocations: [],
  genders: [],
  managers: [],
  departments: [],
  status: [],
  employeeTypes: [],
  query: DEFAULT_EMPLOYEE_QUERY
};

const employeesSliceState = createSlice({
  name: "employees-slice",
  initialState,
  reducers: {
    setEmployees(state, { payload }: PayloadAction<Employee[]>) {
      state.employees = payload;
    },
    setEmployee(state, { payload }: PayloadAction<Employee | null>) {
      state.employee = payload;
    },
    setIsLoadingEmployees(state, { payload }: PayloadAction<boolean>) {
      state.isLoadingEmployees = payload;
    },
    setEmployeeCount(state, { payload }: PayloadAction<number>) {
      state.employeeCount = payload;
    },
    setEmployeeQuery(state, { payload }: PayloadAction<IEmployeeQueryParams>) {
      state.query = payload;
    },
    setEmployeeSearchFields(
      state,
      {
        payload,
      }: PayloadAction<{
        jobTitles: JobTitle[];
        officeLocations: OfficeLocation[];
        genders: Gender[];
        employees: Employee[];
        departments: Department[];
        status: Status[];
        employeeTypes: EmployeeType[]
      }>,
    ) {
      state.jobTitles = payload.jobTitles;
      state.departments = payload.departments;
      state.officeLocations = payload.officeLocations;
      state.genders = payload.genders;
      state.managers = payload.employees;
      state.status = payload.status;
      state.employeeTypes = payload.employeeTypes
    },
  },
});

export const {
  setEmployees,
  setEmployee,
  setIsLoadingEmployees,
  setEmployeeCount,
  setEmployeeQuery,
  setEmployeeSearchFields,
} = employeesSliceState.actions;

export default employeesSliceState.reducer;
